var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtn3Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_User_Line",
    "data-name": "icons/User/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 20,
    viewBox: "0 0 13.333 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.667,2.5a.833.833,0,0,0,.833.833H4.167A.833.833,0,0,0,5,2.5V0H6.667V2.5A2.5,2.5,0,0,1,4.167,5H2.5A2.5,2.5,0,0,1,0,2.5V0H1.667Z",
    transform: "translate(3.333 15)",
    fill: "#777e90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M8.333,15.833H5a2.5,2.5,0,0,1-2.5-2.5V11.871a6.667,6.667,0,1,1,8.333,0v1.462A2.5,2.5,0,0,1,8.333,15.833ZM6.667,1.666a5,5,0,0,0-3.125,8.9l.625.5v2.263A.834.834,0,0,0,5,14.167H8.333a.834.834,0,0,0,.833-.833V11.071l.625-.5a5,5,0,0,0-3.125-8.9Z",
    fill: "#777e90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M.244.244a.833.833,0,0,0,0,1.179L1.667,2.845V7.5H3.333V2.845L4.756,1.423A.833.833,0,0,0,3.577.244L2.5,1.321,1.423.244A.833.833,0,0,0,.244.244Z",
    transform: "translate(4.167 6.667)",
    fill: "#777e90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn3Icon);
export default __webpack_public_path__ + "static/media/btn3icon.b465d59fc991cda69074803eb4601a28.svg";
export { ForwardRef as ReactComponent };